import { wrapper, privacyText } from "./styles";
import GetInTouchForm from "@/components/forms/get-in-touch";
import PrivacyText from "@/components/privacy-text";
import {useTranslation} from "react-i18next";

const ContactForm = () => {
    const {t} = useTranslation()
    return (
        <div className={wrapper} title={t("contact.form.seo.title")} aria-label={t("contact.form.seo.aria-label")}>
            <GetInTouchForm formClassName="GA4-LeadConversion" productOfInterest={true} message={true} />
            <div className={privacyText}>
                <PrivacyText fontSize="text-xs" />
            </div>
        </div>
    );
};

export default ContactForm;
